// extracted by mini-css-extract-plugin
module.exports = {"rangeContainer":"Range_rangeContainer__vTmQ0","wrapper":"Range_wrapper__vViVe","rangeLabel":"Range_rangeLabel__k7u75","currentValue":"Range_currentValue__XCBWz"};